import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DetalleRondaPage } from './detalle-ronda';
import { PipesModule } from '../../pipes/pipes.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    DetalleRondaPage,
  ],
  imports: [
    IonicPageModule.forChild(DetalleRondaPage),
    PipesModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class DetalleRondaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/detalle-ronda/detalle-ronda.module.ts